import Loadable from 'UIComponents/decorators/Loadable';
const AsyncConfirmDeleteCommentModal = Loadable({
  loader: () => import(
  /* webpackChunkName: "confirm-delete-comment-modal" */
  './ConfirmDeleteCommentModal').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncConfirmDeleteCommentModal;